import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function Input({ label, input, type, step, hint, half, inline, placeholder, labelClassName, icon,
  inputClassName, className, required, checkboxLabel, darkIcon, autoComplete, meta: { error, warning, touched } }) {

  return (
    <div
      className={
        cn({
          FormRow: true,
          'FormRow--half': half,
          'FormRow--inline': inline,
          'FormRow--checkboxLabel': checkboxLabel,
        }, className)
      }
    >
      {label &&
        <label
          className={cn({ FormLabel: true, 'FormLabel--required': required }, labelClassName)}
          htmlFor={input.name}
        >
          {label}
        </label>
      }

      {icon &&
        <div className={cn("TextInput-iconContainer", {
          'TextInput-iconContainer--dark': darkIcon,
        })}>
          <div className="TextInput-icon">{icon}</div>
          <input
            {...input}
            id={input.name}
            placeholder={placeholder}
            className={cn("TextInput", inputClassName)}
            type={type}
            step={step}
            required={required}
            aria-required={required}
            aria-invalid={touched && !!error}
            aria-describedby={touched && (error || warning) ? `${input.name}-error` : undefined}
            autoComplete={autoComplete}
          />
        </div>
      }

      {!icon &&
        <input
          {...input}
          id={input.name}
          placeholder={placeholder}
          className={cn("TextInput", inputClassName)}
          type={type}
          step={step}
          required={required}
          aria-required={required}
          aria-invalid={touched && !!error}
          aria-describedby={touched && (error || warning) ? `${input.name}-error` : undefined}
          autoComplete={autoComplete}
        />
      }

      {checkboxLabel &&
        <label className="checkboxLabel" htmlFor={input.name}>{checkboxLabel}</label>
      }

      {hint &&
        <div className="hint">
          {hint}
        </div>
      }

      {touched && (error || warning) &&
        <div className="ErrorExplanation" id={`${input.name}-error`} role="alert">
          {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
      }
    </div>
  );
};

Input.propTypes = {
  input: PropTypes.object,
  error: PropTypes.string,
  type: PropTypes.string,
  // A number field defaults to step=1, which rejects a half-foot width.
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pattern: PropTypes.string,
  hint: PropTypes.node,
  touched: PropTypes.bool,
  half: PropTypes.bool,
  required: PropTypes.bool,
  warning: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object
};

export default Input;
